import React, { useState, useEffect } from "react";
import { Button, InputNumber, Table, message } from "antd";
import ModalCommon from "../../components/Modal";
import { TEXT_DEF } from "../../constant/text";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";

const SetupScore = () => {
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);
  const [, contextHolder] = message.useMessage();

  // Dữ liệu VIP với điểm MAX - khởi tạo rỗng để tránh hiển thị giá trị mặc định
  const [vipData, setVipData] = useState([]);

  useEffect(() => {
    getDataConfig();
  }, []);

  const getDataConfig = async () => {
    try {
      const res = await API.get(`${CONFIG}`);
      const responseData = res.data?.data || res.data;
      
      // Parse vipLevels từ API
      if (responseData.vipLevels) {
        const vipLevelsArray = Object.entries(responseData.vipLevels).map(([key, value]) => {
          // key format: "VIP_0_5" -> "0-5", "VIP_12_15" -> "12-15"
          const vipKey = key.replace("VIP_", "").replace(/_/g, "-");
          // vipLabel: "VIP_0_5" -> "VIP 0 - 5", "VIP_12_15" -> "VIP 12 - 15"
          const vipLabel = key.replace("VIP_", "VIP ").replace(/_/g, " - ");
          
          return {
            key: vipKey,
            vipLevel: vipLabel,
            maxPoints: value.MAX_SCORE || 0,
            minPoints: value.MIN_SCORE || 0,
            bombRate: value.BOMB_RATE || 0,
            personRate: value.PERSON_RATE || 0,
          };
        });
        
        // Sort by key để đảm bảo thứ tự đúng
        vipLevelsArray.sort((a, b) => {
          const aNum = parseInt(a.key.split("-")[0]);
          const bNum = parseInt(b.key.split("-")[0]);
          return aNum - bNum;
        });
        
        setVipData(vipLevelsArray);
      }
    } catch (err) {
      // Error handling
    }
  };

  const handleUpdateConfig = async () => {
    try {
      // Convert vipData thành format vipLevels cho API
      const vipLevels = {};
      vipData.forEach((item) => {
        // Convert key "0-5" -> "VIP_0_5", "12-15" -> "VIP_12_15"
        const vipKey = `VIP_${item.key.replace(/-/g, "_")}`;
        vipLevels[vipKey] = {
          MAX_SCORE: item.maxPoints,
          MIN_SCORE: item.minPoints,
          BOMB_RATE: item.bombRate,
          PERSON_RATE: item.personRate,
        };
      });

      const body = {
        config: {
          vipLevels: vipLevels
        }
      };

      await API.patch(`${UPDATE_CONFIG}`, body);
      setIsShowModalConfirm(false);
      setIsShowModalSuccess(true);
      // Don't reload from API to avoid "jumping" effect - vipData already has the updated values
    } catch (err) {
      message.error("Cập nhật thất bại");
      setIsShowModalConfirm(false);
    }
  };

  const handleShowModal = () => setIsShowModalConfirm(true);

  const handleUpdateMaxPoints = (key, value) => {
    setVipData((prev) =>
      prev.map((item) => (item.key === key ? { ...item, maxPoints: Number(value) || 0 } : item))
    );
  };


  const vipColumns = [
    {
      title: "VIP",
      dataIndex: "vipLevel",
      key: "vipLevel",
      width: 200,
      align: "center",
    },
    {
      title: "ĐIỂM MAX",
      dataIndex: "maxPoints",
      key: "maxPoints",
      align: "center",
      render: (text, record) => (
        <InputNumber
          value={text}
          min={0}
          style={{ width: "100%" }}
          onChange={(value) => handleUpdateMaxPoints(record.key, value)}
        />
      ),
    },
  ];

  return (
    <div className="col-12" style={{ padding: "20px" }}>
      {contextHolder}

      {/* Bảng cấu hình VIP */}
      {vipData.length > 0 && (
        <>
          <div style={{ marginBottom: "40px" }}>
            <Table
              columns={vipColumns}
              dataSource={vipData}
              pagination={false}
              bordered
              style={{ maxWidth: "800px" }}
            />
          </div>
          <Button type="primary" style={{ marginTop: 20 }} onClick={handleShowModal}>
            Cập nhật
          </Button>
        </>
      )}

      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}
      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}
    </div>
  );
};

export default SetupScore;
